import { Button } from "@mui/material";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { NormalSecondaryButton } from "@/styles/globalstyles";
import { Link as RouterLink } from "react-router-dom";

const BackButton = ({ to }: { to: string }) => {
    return (
        <Button component={RouterLink} to={to} size="small" variant="outlined" sx={{ ...NormalSecondaryButton, fontSize: '0.75rem' }} startIcon={<KeyboardBackspaceIcon />}>
            Back
        </Button>
    );
};

export default BackButton;  